// Test IDs for the Founder Energy Restored landing page.
// Naming: keys camelCase, values kebab-case "<feature>-<element>".

export const LANDING = {
    // Nav
    navLogo: "landing-nav-logo",
    navAbout: "landing-nav-about",
    navAdvisory: "landing-nav-advisory",
    navInfluencer: "landing-nav-influencer",
    navMasterclass: "landing-nav-masterclass",
    navPricing: "landing-nav-pricing",
    navWorkWithMe: "landing-nav-work-with-me",
    navJoinBtn: "landing-nav-join-btn",

    // Hero
    heroJoinBtn: "landing-hero-join-btn",
    heroWorkWithMeBtn: "landing-hero-work-with-me-btn",
    heroHeadshot: "landing-hero-headshot",

    // Waitlist (legacy / community form — keeping the test IDs)
    waitlistEmailInput: "landing-waitlist-email-input",
    waitlistSubmitBtn: "landing-waitlist-submit-btn",
    waitlistSuccess: "landing-waitlist-success",

    // Current Work
    currentWorkEmailLink: "landing-current-work-email-link",

    // Two Paths
    twoPathsCompaniesBtn: "landing-two-paths-companies-btn",
    twoPathsIndividualsBtn: "landing-two-paths-individuals-btn",

    // Advisory & Consulting
    advisoryContactBtn: "landing-advisory-contact-btn",
    advisoryEmailLink: "landing-advisory-email-link",

    // Pricing
    pricingFoundingBtn: "landing-pricing-founding-btn",
    pricingStandardBtn: "landing-pricing-standard-btn",
    pricingEmailInput: "landing-pricing-email-input",
    pricingNameInput: "landing-pricing-name-input",

    // Newsletter
    newsletterEmailInput: "landing-newsletter-email-input",
    newsletterSubmitBtn: "landing-newsletter-submit-btn",
    newsletterSuccess: "landing-newsletter-success",

    // The Weekly (between Future Vision and Guarantee)
    weeklyEmailInput: "landing-weekly-email-input",
    weeklySubmitBtn: "landing-weekly-submit-btn",
    weeklySuccess: "landing-weekly-success",

    // Enquiries
    enquiryNameInput: "landing-enquiry-name-input",
    enquiryEmailInput: "landing-enquiry-email-input",
    enquiryTypeSelect: "landing-enquiry-type-select",
    enquiryMessageInput: "landing-enquiry-message-input",
    enquirySubmitBtn: "landing-enquiry-submit-btn",
    enquirySuccess: "landing-enquiry-success",
    footerContactLink: "landing-footer-contact-link",

    // Founding cohort (replaces testimonials)
    foundingCohortBtn: "landing-founding-cohort-btn",

    // Success page
    successTitle: "landing-success-title",
    successStatus: "landing-success-status",
    successHome: "landing-success-home",
};
